import { NotificationChannel } from "../model/step";

export const Constants: {
    ChannelIcon: Record<NotificationChannel, JSX.Element | null>
} = {
    ChannelIcon: {
        [NotificationChannel.None]: <i />,
        [NotificationChannel.Email]: <i className="fa-solid fa-envelope" />,
        [NotificationChannel.App]: <i className="fa-solid fa-bell" />,
        [NotificationChannel.Teams]: <i className="fa-brands fa-microsoft" />
    }
}